import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import cvData from "../data/cvData";
import { backdropFade, scalePop } from "../utils/motionVariants";
import "./CalendlyModal.css";

export default function CalendlyModal({ open, onClose }) {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const url = "https://calendly.com/hirunkolongahapitiya/let-s-connect?hide_event_type_details=1&hide_gdpr_banner=1";
  const { name, title, location } = cvData;
  const eventMeta = [
    { label: "Duration", value: "30 minutes" },
    { label: "Timezone", value: "Sri Lanka / GMT +5:30" },
  ];

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="calendly-backdrop"
          onClick={onClose}
          variants={backdropFade}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <motion.div
            className="calendly-dialog"
            onClick={(e) => e.stopPropagation()}
            variants={scalePop}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <div className="calendly-card">
              <motion.button
                className="calendly-close"
                onClick={onClose}
                aria-label="Close scheduling form"
                whileHover={{ scale: 1.15, rotate: 90 }}
                whileTap={{ scale: 0.9 }}
                transition={{ duration: 0.2 }}
              >
                &times;
              </motion.button>

              <div className="calendly-host-pane">
                <motion.div
                  className="calendly-avatar"
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.15, duration: 0.4 }}
                >
                  <img src="/assets/profile.jpg" alt={`${name} portrait`} loading="lazy" />
                </motion.div>
                <p className="calendly-host-eyebrow">Let's connect</p>
                <h3>{name}</h3>
                <p className="calendly-host-role">{title}</p>
                <p className="calendly-host-location">{location}</p>

                <div className="calendly-host-tags">
                  {eventMeta.map((meta, idx) => (
                    <motion.div
                      key={meta.label}
                      initial={{ opacity: 0, y: 8 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.25 + idx * 0.08 }}
                    >
                      <span>{meta.label}</span>
                      <strong>{meta.value}</strong>
                    </motion.div>
                  ))}
                </div>

                <p className="calendly-host-note">
                  I'll guide you through next steps, gather context, and map out a clear plan before we dive into delivery.
                </p>
              </div>

              <div className="calendly-embed">
                <header>
                  <p className="eyebrow">Scheduling</p>
                  <h4>Pick a time that works best for you</h4>
                  <p className="muted">
                    You'll receive a calendar invite with all meeting details right after booking.
                  </p>
                </header>
                <iframe
                  src={url}
                  title="Schedule with Hirun Kolongahapitiya"
                  frameBorder="0"
                  allow="camera; microphone; fullscreen"
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
